module.exports = __webpack_public_path__ + "static/media/video-caller.79dbf418.jpg";